import React, { useRef, useState } from 'react'
import { SelectValue } from 'antd/lib/select'
import dp from 'dot-prop-immutable'

import { Select } from 'src/components/Formik'
import { SelectProps } from 'src/components/Formik/Select'
import CountriesService from 'src/services/api/countries'
import { AddressCountry } from 'src/types'

type Props = Omit<SelectProps, 'loading' | 'options'>

export default function SelectCountry({
  defaultActiveFirstOption = true,
  formikProps,
  name,
  style,
  onChange,
  ...props
}: Props) {
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState<AddressCountry[]>([])
  const [searchValue, setSearchValue] = useState<string>()

  const refTimeout = useRef<NodeJS.Timeout>(null)

  function setFieldValue(value: string) {
    formikProps.setFieldValue(name, value)

    formikProps.setFieldValue(
      name.replace('_id', ''),
      list.find(item => +item.country_id === +value)
    )
  }

  return (
    <Select
      {...props}
      dataTestId="country-list"
      defaultActiveFirstOption={defaultActiveFirstOption}
      filterOption={false}
      formikProps={formikProps}
      loading={loading}
      name={name}
      style={style}
      onChange={(
        value: SelectValue,
        option: React.ReactElement<any> | React.ReactElement<any>[]
      ) => {
        setFieldValue(`${value}`)
        onChange && onChange(value, option)
      }}
      onSearch={value => {
        setSearchValue(value)

        if (value) {
          clearTimeout(refTimeout.current)

          refTimeout.current = setTimeout(async () => {
            setLoading(true)

            const response = await CountriesService.getAll({
              queryName: value
            })

            setLoading(false)

            if (response.data) {
              setList(response.data)
            }
          }, 500)
        }
      }}
      options={
        !searchValue && dp.get(formikProps.values, name)
          ? (() => {
              const countryObj = dp.get(
                formikProps.values,
                name.replace('_id', '')
              )

              return [
                {
                  label: countryObj?.name,
                  title: countryObj?.name,
                  value: `${countryObj?.country_id}`
                }
              ]
            })()
          : list.map(country => ({
              label: country.name,
              title: country.name,
              value: `${country.country_id}`
            }))
      }
      showSearch
    />
  )
}
